<template>
  <div id="app">
    <div class="variable">
      <transition name="move-fade-right-to-left">
        <router-view class="app-router-view"></router-view>
      </transition>
    </div>
    <!-- <div class="myfoot">copyright @2018-2019 广州琅粤生物科技有限公司 版权所有</div> -->
  </div>
</template>

<script>
// import 'vue-transition.css'
export default {
  name: 'App'
}
</script>

<style lang="stylus">
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    height: 100%;
    display: flex;
    min-height: 100%; 
    flex-flow: row wrap;
  }
  *{
    padding: 0;
    margin: 0;
  }
  html,
  body,
  .app {
    position: relative;
    width: 100%;
    height: 100%;
    /*overflow: hidden;*/
  }
  .app {
    background-color: #000;
    perspective: 1200px;
  }

  .app .app-router-view {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    overflow: hidden;
    backface-visibility: hidden;
    transform: translate3d(0, 0, 0);
    transform-style: preserve-3d;
    visibility: visible;
  }
  .app-router-view {
    /* height: 100%; */
  }
  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  a {
    color: #42b983;
  }
  .variable {
    width: 100%;
    height: 100%
    // align-self: flex-start;
  }
  .comond_btn {
    button {
      background-color #1f1f1f !important
      border-color #1f1f1f !important
    }
  }
  </style>
